import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { rhythm } from '../utils/typography'
import {PageTop, TitleH1, Title, SidebarNews, InfoBlock, Main, Content, Row, Col2 } from '../layouts/layouts'
import SideBarRight from '../layouts/SideBarRight'
import Gallery from '../layouts/gallery'

const Col22 = Col2.extend`
  margin: 0 ${rhythm(0.25)};
`

import img from '../assets/lokki-289x217-2463.jpg'

class Hinnasto extends React.Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Kirsti Louko - Hinnasto</title>
        </Helmet>
        <PageTop>
          <TitleH1>HINNASTO</TitleH1>
          <p>Minulla on Kelan kanssa valtakirjasopimus, joka oikeuttaa perimään asiakkaalta hoidon omavastuuosuuden ja hakemaan asiakkaan puolesta korvauksen.</p>
        </PageTop>
        <Content>
        <SideBarRight view="hinnasto"/>
        <Main>
          <Col22>
            <InfoBlock full>
              <Title small>PSYKOTERAPIA</Title>
              <div className="content-info">
              <p><strong>Yksilöpsykoterapiakäynti</strong><br/>
              Kesto: 45min <br/>
              Hinta: 80€ <br/></p>

              <p><strong>Lisätiedot</strong></p>

              <p>KELA korvaa lääkärin lähetteellä 16-67-vuotiaille kuntoutuspsykoterapiasta
              57,60€ kerralta.</p>
              <p><Link to="/psykoterapia">Katso esittely</Link></p>
              </div>
            </InfoBlock>
            <InfoBlock full>
              <img src={img}/>
            </InfoBlock>

          </Col22>
          <Col22>
            {/* <InfoBlock full>
              <Title small>SEKSUAALINEUVONTA</Title>
              <div className="content-info">
              <p><strong>Tutustumiskäynti</strong><br/>
              Kesto: 45min <br/>
              Hinta: 40€ <br/></p>

              <p><strong>Seksuaalineuvonta </strong><br/>
              Kesto: 45-60min. <br/>
              Hinta: 70€ <br/></p>

              <p><Link to="/seksuaalineuvonta">Katso esittely</Link></p>
              </div>
            </InfoBlock> */}
            <InfoBlock full>
              <Title small>TYÖNOHJAUS</Title>
              <div className="content-info">
              <p><strong>Hinnat sovitaan asiakkaan kanssa toimeksiannon laajuudesta riippuen.</strong></p>

              <p><Link to="/tyonohjaus">Katso esittely</Link></p>
              </div>
            </InfoBlock>

          </Col22>
          </Main>

        </Content>

      </div>
    )
  }
}

export default Hinnasto;



// WEBPACK FOOTER //
// ./src/pages/hinnasto.js